import React, { useState, useEffect } from 'react';
import { Card, Table, Badge, Spinner, Alert } from 'react-bootstrap';
import PaymentService from './PaymentService';

const WODPaymentsList = () => {
  const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (dateArray) => {
    if (!dateArray || !Array.isArray(dateArray)) return 'N/A';
    
    const [year, month, day, hour, minute, second] = dateArray;
    const date = new Date(year, month - 1, day, hour, minute, second);
    
    // Format as DD/MM/YYYY HH:MM
    const dayStr = String(date.getDate()).padStart(2, '0');
    const monthStr = String(date.getMonth() + 1).padStart(2, '0');
    const yearStr = date.getFullYear();
    const hourStr = String(date.getHours()).padStart(2, '0');
    const minuteStr = String(date.getMinutes()).padStart(2, '0');
    
    return `${dayStr}/${monthStr}/${yearStr} ${hourStr}:${minuteStr}`;
  };

  const formatAmount = (amount, currency) => {
    const symbol = currency === 'gbp' ? '£' : currency === 'usd' ? '$' : '€';
    return `${symbol}${amount.toFixed(2)}`;
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'succeeded': 'success',
      'pending': 'warning',
      'failed': 'danger',
      'canceled': 'secondary'
    };
    
    return (
      <Badge bg={statusMap[status] || 'secondary'}>
        {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown'}
      </Badge>
    );
  };

  useEffect(() => {
    setIsLoading(true);
    PaymentService.retrievePaymentsByAccount()
      .then(data => {
        // Sort by paymentDate descending (most recent first)
        const sortedPayments = data.sort((a, b) => {
          if (!a.paymentDate || !b.paymentDate) return 0;
          
          const dateA = new Date(
            a.paymentDate[0], 
            a.paymentDate[1] - 1, 
            a.paymentDate[2], 
            a.paymentDate[3] || 0, 
            a.paymentDate[4] || 0, 
            a.paymentDate[5] || 0
          );
          const dateB = new Date(
            b.paymentDate[0], 
            b.paymentDate[1] - 1, 
            b.paymentDate[2], 
            b.paymentDate[3] || 0, 
            b.paymentDate[4] || 0, 
            b.paymentDate[5] || 0
          );
          
          return dateB - dateA; // Descending order
        });
        
        setPayments(sortedPayments);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching payments:', error);
        setError(error.message);
        setIsLoading(false);
      });
  }, []);

  return (
    <Card>
      <Card.Header>
        <h5 className="text-primary">Payments</h5>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : error ? (
          <Alert variant="danger">
            Error loading payments: {error}
          </Alert>
        ) : payments.length === 0 ? (
          <Alert variant="info">
            No payments found.
          </Alert>
        ) : (
          <div className="table-responsive">
            <Table hover>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Payment ID</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment, index) => (
                  <tr key={payment.paymentIntentId || index}>
                    <td>{formatDate(payment.paymentDate)}</td>
                    <td>{payment.customerName || 'N/A'}</td>
                    <td>{payment.customerEmail || 'N/A'}</td>
                    <td className="fw-semibold">
                      {formatAmount(payment.amount, payment.currency)}
                    </td>
                    <td>{getStatusBadge(payment.status)}</td>
                    <td>
                      <small className="text-muted">
                        {payment.paymentIntentId ? 
                          payment.paymentIntentId.substring(0, 20) + '...' : 
                          'N/A'
                        }
                      </small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default WODPaymentsList;
